/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CustomTable from '../CustomTable/CustomTable';

import { numberWithSpacesInter } from '../../helpers/formatInteger';
import './styles.scss';
import { useSelector } from 'react-redux';
import { textSort } from '../../helpers/textSort';
import CustomSortIcon from '../CustomSortIcon/CustomSortIcon';

export const PortfolioTableOptimal = ({
  tableColumns,
  setTableColumns,
  optimalPortfolio,
}) => {
  const { t } = useTranslation('');

  const { isLoading } = useSelector((state) => state.portfolioReducer);

  const data = optimalPortfolio
    ?.map((row, index) => {
      return {
        key: index,
        financialInstrumentName: row.name,
        value: row.value,
        fee: row.fee,
        assetClass: row?.asset_class_name,
        weight: row.current_weight_fin,
      };
    })
    .sort((a, b) => b.value - a.value);

  useEffect(() => {
    const defaultColumns = [
      {
        title: t('INSTRUMENT'),
        dataIndex: 'financialInstrumentName',
        className: 'name',
        sortIcon: (props) => <CustomSortIcon {...props} />,
        sorter: (a, b) =>
          textSort(a.financialInstrumentName, b.financialInstrumentName),
      },
      {
        title: t('VALUE'),
        dataIndex: 'value',
        className: 'table-header-right',
        width: '10%',
        align: 'right',
        render: (value) => `${numberWithSpacesInter(value, 0)} kr`,
        sortIcon: (props) => <CustomSortIcon {...props} />,
        sorter: (a, b) => a.value - b.value,
      },
      {
        title: t('WEIGHT'),
        dataIndex: 'weight',
        className: 'table-header-right weight',
        width: '10%',
        align: 'right',
        render: (value) => {
          return `${numberWithSpacesInter(value, 2)}%`;
        },
        sortIcon: (props) => <CustomSortIcon {...props} />,
        sorter: (a, b) => a.weight - b.weight,
      },
      {
        title: t('FEE'),
        dataIndex: 'fee',
        className: 'holdings-fee table-header-center',
        width: '10%',
        align: 'center',
        render: (value) => {
          return <p>{numberWithSpacesInter(value, 2)}%</p>;
        },
        sortIcon: (props) => <CustomSortIcon {...props} />,
        sorter: (a, b) => a.fee - b.fee,
      },
      {
        title: t('ASSET_CLASS'),
        dataIndex: 'assetClass',
        width: '20%',
        sorter: (a, b) => {
          if (a.assetClass < b.assetClass) {
            return 1;
          } else if (a.assetClass > b.assetClass) {
            return -1;
          } else {
            return 0;
          }
        },
        sortIcon: (props) => <CustomSortIcon {...props} />,
        render: (value, record) => {
          return (
            <>
              <p className="holdings-assetclass-cell-asset">{value}</p>
              <p className="holdings-assetclass-cell-category">
                {record.financialAssetCategory}
              </p>
            </>
          );
        },
      },
    ];
    setTableColumns(defaultColumns);
  }, [optimalPortfolio]);

  return (
    <div className="client portfolio-table sugg-portfolio">
      <CustomTable
        loading={isLoading}
        columns={tableColumns}
        dataSource={data}
        rowHoverable={false}
        size="middle"
        pagination={false}
      />
    </div>
  );
};

PortfolioTableOptimal.propTypes = {
  columns: PropTypes.array,
  optimalPortfolio: PropTypes.array,
  tableColumns: PropTypes.array,
  setTableColumns: PropTypes.func,
};
